const Limits = Object.freeze({
  TRIP_DURATION: 21,
} as const);

export type Limits = (typeof Limits)[keyof typeof Limits];
export const allLimits: [Limits, ...Limits[]] = Object.values(Limits) as [Limits, ...Limits[]];

export default Limits;
